import "@fontsource/roboto"

const logScrollState = (label, location) => {
  if (typeof window === 'undefined') {
    return;
  }
  const root = document.getElementById('___gatsby');
  // console.log(`[scroll-debug] ${label}`, {
  //   path: location?.pathname,
  //   hash: location?.hash,
  //   windowY: window.scrollY,
  //   docTop: document.documentElement.scrollTop,
  //   bodyTop: document.body.scrollTop,
  //   gatsbyTop: root ? root.scrollTop : null,
  // });
};

const forceScrollTop = () => {
  if (typeof window === 'undefined') {
    return;
  }
  const html = document.documentElement;
  const body = document.body;
  const prevHtmlBehavior = html.style.scrollBehavior;
  const prevBodyBehavior = body ? body.style.scrollBehavior : '';
  html.style.scrollBehavior = 'auto';
  if (body) {
    body.style.scrollBehavior = 'auto';
  }
  const scroller = document.scrollingElement || document.documentElement;
  scroller.scrollTop = 0;
  if (body) {
    body.scrollTop = 0;
  }
  window.scrollTo(0, 0);
  const root = document.getElementById('___gatsby');
  if (root) {
    root.scrollTop = 0;
  }
  window.setTimeout(() => {
    html.style.scrollBehavior = prevHtmlBehavior;
    if (body) {
      body.style.scrollBehavior = prevBodyBehavior;
    }
  }, 200);
};

export const onPreRouteUpdate = ({ location }) => {
  logScrollState('route-update-pre', location);
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window === 'undefined') {
    return;
  }
  logScrollState('route-update-start', location);
  if (location?.hash) {
    const targetId = decodeURIComponent(location.hash.replace('#', ''));
    window.requestAnimationFrame(() => {
      const el = document.getElementById(targetId);
      if (el) {
        el.scrollIntoView({ behavior: 'auto', block: 'start' });
        window.setTimeout(() => logScrollState('route-update-hash', location), 0);
      } else {
        forceScrollTop();
        window.setTimeout(() => logScrollState('route-update-top', location), 0);
      }
    });
    return;
  }
  forceScrollTop();
  window.requestAnimationFrame(forceScrollTop);
  window.setTimeout(() => logScrollState('route-update-top', location), 0);
};

export const shouldUpdateScroll = () => false;

export const onClientEntry = () => {
  if (typeof window === 'undefined') {
    return;
  }
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
};
